module.exports = __webpack_public_path__ + "img/impresora.07b29e7f.svg";